export default __webpack_public_path__ + "static/media/smiley_1.c01c9026.svg";